import React from 'react'
import { useTranslation } from 'react-i18next'
import { Dumbbell, HeartPulse, Sparkles, Waves } from 'lucide-react'
import { Card, CardContent } from '../../../components/ui/card'
import { cn } from '../../../lib/utils'

const TYPES = [
  { id: 'day1_chest_back', icon: Dumbbell },
  { id: 'day2_arms_shoulders', icon: Dumbbell },
  { id: 'day3_legs', icon: Dumbbell },
  { id: 'swim', icon: Waves },
  { id: 'cardio_only', icon: HeartPulse },
  { id: 'custom', icon: Sparkles },
]

export default function SessionTypeSelector({ value, onPick }) {
  const { t } = useTranslation()
  return (
    <Card>
      <CardContent className="p-4">
        <p className="text-sm text-muted-foreground mb-3">{t('workout.session.pickType')}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
          {TYPES.map(({ id, icon: Icon }) => {
            const selected = value === id
            return (
              <button
                key={id}
                type="button"
                onClick={() => onPick(id)}
                className={cn(
                  'flex items-start gap-3 p-3 rounded-lg border text-start transition-all',
                  selected
                    ? 'border-app-primary-500 bg-app-primary-50 dark:bg-app-primary-900/20'
                    : 'border-border bg-card hover:border-app-primary-500/40 hover:shadow-sm'
                )}
              >
                <div
                  className={cn(
                    'rounded-full p-2 flex-shrink-0',
                    selected
                      ? 'bg-app-primary-500 text-white'
                      : 'bg-app-primary-100 text-app-primary-500 dark:bg-app-primary-900/30'
                  )}
                >
                  <Icon className="w-4 h-4" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium text-foreground">
                    {t(`workout.sessionType.${id}`)}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {t(`workout.sessionType.${id}_desc`)}
                  </p>
                </div>
              </button>
            )
          })}
        </div>
      </CardContent>
    </Card>
  )
}
